import { styled } from '@material-ui/core';

export const ImageMedia = styled('img')(({ theme }) => ({
  maxHeight: 80,
  objectFit: 'cover',
  borderRadius: 8,
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.7,
    backgroundColor: theme.palette.type === 'dark' ? '#1c2530' : '#e4e8f0',
  },
  transition: 'opacity 0.3s',
}));

export const FileItem = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#1f2733' : '#f7f7f7',
  width: '100%',
  height: 46,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  padding: '10px 15px',
  cursor: 'pointer',
  '& > p': {
    maxWidth: 250,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20,
    marginRight: 7,

    '& svg path': {
      fill: '#3e8bff',
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.type === 'dark' ? '#1c2530' : '#e4e8f0',
  },
}));
